import React from 'react';
import { Card } from "react-bootstrap";
import face_laszlo_csato from "../../assets/img/3.png";
import ShowMoreText from "react-show-more-text";
import proj_UEFA_balance from "../../assets/img/proj_UEFA_balance.png";

const Laszlo_Csato_UEFA_balance = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_UEFA_balance} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_laszlo_csato}
              /* this will be the text on the banner */
              alt="Analyzing competitive balance in the UEFA Champions League"
            />{" "}
            <p className="text7">László Csató</p>
            <br />
            <p className="text8">
              Research Fellow{" "}
            </p>
            <p className="text8">Research Group of Operations Research and Decision Systems, SZTAKI </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            Ensuring competitive balance is a key goal for any tournament organiser, 
            including the Union of European Football Association (UEFA). This project 
            aims to quantify both ex ante and ex post competitive balance in the group 
            stage of the most prestigious European club football competition, the UEFA 
            Champions League. For this purpose, novel measures will be used since 
            previous studies suffer from some shortcomings.
            <br />
            <br />
            Related literature:{" "}

            <ul>
                <li>
                Triguero‐Ruiz, F., & Avila‐Cano, A. (2023). On competitive balance in the 
                group stage of the UEFA Champions League. Scottish Journal of Political Economy, 70(3), 231-248.
                </li>
                <li>
                Csató, L. (2023). Club coefficients in the UEFA Champions League: Time for shift to an Elo-based 
                formula. International Journal of Performance Analysis in Sport, in press.
                </li>
                <li>
                Csató, L., Molontay, R., and Pintér, J. (2023b). Tournament schedules and incentives in a double 
                round-robin tournament with four teams. International Transactions in Operational Research, in press.
                </li>
            </ul>

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Laszlo_Csato_UEFA_balance;